class VariantSelectSync {
  constructor(element) {
    this.element = element;
    this.sectionId = element.dataset.section;
    this.productUrl = element.dataset.url;
    this.pendingRequestVariantId = null;
    this.variantData = this.parseVariantData();
    if (!this.variantData.length) return;

    this.currentVariantId = this.getInitialVariantId();
    this.onChange = this.onChange.bind(this);
    this.element.addEventListener("change", this.onChange);
  }

  parseVariantData() {
    const dataScript = this.element.querySelector("script[data-variant-data]");
    if (!dataScript) return [];

    try {
      return JSON.parse(dataScript.textContent);
    } catch (error) {
      console.error("Unable to parse variant data", error);
      return [];
    }
  }

  getInitialVariantId() {
    const form = document.querySelector(`#product-form-${this.sectionId}`);
    const input = form?.querySelector('input[name="id"]');
    return input ? Number(input.value) : null;
  }

  onChange() {
    const variant = this.findMatchingVariant();
    if (!variant || variant.id === this.currentVariantId) return;

    this.currentVariantId = variant.id;
    this.updateVariantInputs(variant);
    this.refreshFragments(variant);
    this.updateUrl(variant);
    this.publishVariantChange(variant);
  }

  findMatchingVariant() {
    const optionWrappers = Array.from(
      this.element.querySelectorAll("[data-option-position]")
    ).sort(
      (a, b) =>
        Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
    );

    const selectedValues = optionWrappers.map((wrapper) => {
      const checked = wrapper.querySelector('input[type="radio"]:checked');
      if (checked) return checked.value;

      const select = wrapper.querySelector("select");
      if (select) return select.value;

      return null;
    });

    if (selectedValues.some((value) => value === null || value === undefined)) {
      return null;
    }

    return this.variantData.find((variant) =>
      selectedValues.every(
        (value, index) => variant[`option${index + 1}`] === value
      )
    );
  }

  updateVariantInputs(variant) {
    document
      .querySelectorAll(
        `#product-form-${this.sectionId}, #product-form-installment-${this.sectionId}`
      )
      .forEach((form) => {
        const input = form?.querySelector('input[name="id"]');
        if (!input) return;
        input.value = variant.id;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
  }

  buildSectionUrl(variantId) {
    const baseUrl = this.productUrl || window.location.pathname;
    const url = new URL(baseUrl, window.location.origin);
    url.searchParams.set("section_id", this.sectionId);
    url.searchParams.set("variant", variantId);
    return url.toString();
  }

  async refreshFragments(variant) {
    const priceTarget = document.querySelector(
      `[data-price-wrapper="${this.sectionId}"]`
    );
    const addToCartTarget = document.querySelector(
      `[data-add-to-cart-block="${this.sectionId}"]`
    );

    const requestUrl = this.buildSectionUrl(variant.id);
    this.pendingRequestVariantId = variant.id;

    try {
      const response = await fetch(requestUrl);
      if (!response.ok) return;
      const text = await response.text();

      if (this.pendingRequestVariantId !== variant.id) return;

      const html = new DOMParser().parseFromString(text, "text/html");
      this.replaceFragment(html, "data-price-wrapper", priceTarget);
      this.replaceFragment(html, "data-add-to-cart-block", addToCartTarget);
      this.replaceVariantSelects(html);
    } catch (error) {
      console.error("Failed to refresh product content", error);
    }
  }

  replaceFragment(html, attribute, target) {
    if (!target) return;
    const source = html.querySelector(
      `[${attribute}="${this.sectionId}"]`
    );
    if (source) {
      target.innerHTML = source.innerHTML;
    }
  }

  replaceVariantSelects(html) {
    if (!this.element?.parentNode) return;

    const selector = `variant-selects#variant-selects-${this.sectionId}`;
    const updated = html.querySelector(selector);
    if (!updated) return;

    this.element.removeEventListener("change", this.onChange);
    this.element.replaceWith(updated);
    new VariantSelectSync(updated);
  }

  updateUrl(variant) {
    if (
      this.element.dataset.updateUrl === "false" ||
      this.element.closest("quick-add-modal")
    ) {
      return;
    }

    const url = new URL(window.location.href);
    url.searchParams.set("variant", variant.id);
    window.history.replaceState({}, "", url.toString());
  }

  publishVariantChange(variant) {
    if (typeof publish !== "function" || !window.PUB_SUB_EVENTS) return;

    publish(PUB_SUB_EVENTS.variantChange, {
      data: {
        sectionId: this.sectionId,
        variant,
      },
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  document
    .querySelectorAll("variant-selects")
    .forEach((element) => new VariantSelectSync(element));
});
